module.exports = __webpack_public_path__ + "static/media/union4.08b9acd3.png";